import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Linkedin, Twitter, Mail } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isDarkMode } = useTheme();

  const socialLinks = [
    { icon: Github, href: '#', label: 'GitHub' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Mail, href: '#', label: 'Email' }
  ];

  const footerLinks = [
    { to: '/about', label: 'About' },
    { to: '/portfolio', label: 'Portfolio' },
    { to: '/contact', label: 'Contact' }
  ];

  return (
    <footer className={`relative z-10 border-t backdrop-blur-sm ${
      isDarkMode 
        ? 'border-white/10 bg-black/50' 
        : 'border-gray-200 bg-white/80'
    }`}>
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/logo.png" 
                alt="onlzCode Logo" 
                className={`h-16 md:h-20 lg:h-24 w-auto ${!isDarkMode ? 'invert' : ''}`}
              />
            </div>
            <p className={`text-sm leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Crafting digital experiences that transform ideas into powerful, scalable solutions.
            </p>
          </div>

          <div>
            <h3 className={`text-sm font-medium mb-4 uppercase tracking-wider ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>Quick Links</h3>
            <div className="flex flex-col space-y-2">
              {footerLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`text-sm transition-colors duration-300 inline-flex items-center group ${
                    isDarkMode 
                      ? 'text-gray-400 hover:text-white' 
                      : 'text-gray-500 hover:text-gray-900'
                  }`}
                >
                  <span className={`w-0 h-px transition-all duration-300 group-hover:w-3 mr-0 group-hover:mr-2 ${
                    isDarkMode ? 'bg-white' : 'bg-gray-900'
                  }`} />
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className={`text-sm font-medium mb-4 uppercase tracking-wider ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>Connect</h3>
            <div className="flex space-x-4">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className={`transition-all duration-300 hover:scale-110 ${
                      isDarkMode 
                        ? 'text-gray-400 hover:text-white' 
                        : 'text-gray-500 hover:text-gray-900'
                    }`}
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className={`pt-8 border-t ${isDarkMode ? 'border-white/10' : 'border-gray-200'}`}>
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              © {currentYear} onlzCode. All rights reserved.
            </p>
            <p className={`text-xs uppercase tracking-wider ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
              Built with precision
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
